import { render } from "./LogoutModal.vue?vue&type=template&id=e0336dac"
import script from "./LogoutModal.vue?vue&type=script&lang=js"
export * from "./LogoutModal.vue?vue&type=script&lang=js"
script.render = render

export default script